import React, {useRef, useEffect} from 'react';
import {padStart, useGrabbed, useRafLoop} from 'helpers';
import {resolve} from 'store/calendar';
import css from './time-tooltip.module.scss';

export function TimeTooltip() {
  const ref = useRef();
  const grabbed = useGrabbed();

  const [stop, start] = useRafLoop(() => {
    const {clientX, clientY, offset, origin, type} = grabbed ?? {};
    if (type === 'top-handle' && grabbed.start) {
      ref.current.style.transform = `translate(${origin.x + offset.x}px, ${clientY + offset.y}px)`;
      ref.current.innerHTML = `${grabbed.start.time} (${duration(grabbed.end.minutes, grabbed.start.minutes)})`;
    } else if (type === 'bottom-handle' && grabbed.start) {
      ref.current.style.transform = `translate(${origin.x + offset.x}px, ${clientY + offset.y + 24}px)`;
      ref.current.innerHTML = `${grabbed.end.time} (${duration(grabbed.end.minutes, grabbed.start.minutes)})`;
    } else if (type.match(/activity/)) {
      ref.current.style.transform = `translate(${clientX + offset.x}px, ${clientY + offset.y}px)`;
      ref.current.innerHTML = resolve(clientY + offset.y).time;
    }
  }, false);

  useEffect(() => {
    grabbed ? start() : stop();
  }, [grabbed]);

  return (
    <div ref={ref} className={css('tooltip', {hide: !grabbed})} />
  );
}

const duration = (a, b) => {
  const hours = Math.floor((a - b) / 60);
  const minutes = (a - b) % 60;
  return hours ? `${hours}h ${padStart(minutes.toString(), 2, '0')}m` : `${minutes}m`;
};
